import { t } from "../services/utils";
export default {
  WORKOUT_LOG: 1,
  MEAL_LOG: 3,
  POST: 4,
  PROGRESS_PHOTO: 5,
  ASSESSMENT: 6,
  CHECKIN: 8
};